import { BACKEND_ROUTES } from "../../backendRoutes";
import useSWRImmutable from "swr/immutable";

export const useTraitGroupDataTypes = () =>
    useSWRImmutable(
        `${BACKEND_ROUTES.TRAIT_GROUP_DATA_TYPE}?parentInfo=true&deprecated=false`
    );
